// import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

class homeColumn {
  constructor(target){
    // console.log(target);

    gsap.registerPlugin(ScrollTrigger);
    // var gsap = global.gsap;

    window.allowFloatCheck = Date.now();

    if(!target.inited) {
      target.inited = true;

      this.run = true;
      window.scrubvarsoffset = 0;

      var self = target;
      this.self = target;
      // this.index = $(target).index();
      var parent = this;
      this.blocks = [];
      this.floaterBlocks = [];

      this.initFloaters();

      this.iteration = 0;

      var container = $(self);
      var scroller = $(self).find('.home--cols--col--inner');
      this.children = $(self).find('.home--col--block');

      // set initial state of items
      gsap.set(this.children, {yPercent: 0, opacity: 1});

      gsap.set(scroller, {height: () => innerHeight * this.children.length});

      // spacing of the images (stagger)
      this.spacing = 1;

      // we'll use this to snapTime the playhead on the seamlessLoop
      this.snapTime = gsap.utils.snap(this.spacing);
      // this.images = gsap.utils.toArray('.home--col--block');
      this.images = gsap.utils.toArray(this.children);
      // console.log(this.images);

      // console.log(gsap.timeline());

      // this function will get called for each element in the buildSeamlessLoop() function, and we just need to return an animation that'll get inserted into a master timeline, spaced
      this.animateFunc = function(element){
        const tl = gsap.timeline();
        // console.log(tl);
        // console.log(element.index);
        // tl.fromTo(element, {opacity: 0}, {opacity: 1, zIndex: 100, duration: 0.5, yoyo: false, repeat: 1, ease: "power1.in", immediateRender: false})
        tl.fromTo(element, {yPercent: -100}, {yPercent: 100, duration: 2, ease: "none", immediateRender: false});
        return tl;
      };
      // console.log(this.images, this.spacing, this.animateFunc);
      this.seamlessLoop = this.buildSeamlessLoop(this.images, this.spacing, this.animateFunc);


      // a proxy object we use to simulate the playhead position, but it can go infinitely in either direction and we'll just use an onUpdate to convert it to the corresponding time on the seamlessLoop timeline.
      this.playhead = {offset: 0};

      // feed in any offset (time) and it'll return the corresponding wrapped time (a safe value between 0 and the seamlessLoop's duration)
      this.wrapTime = gsap.utils.wrap(0, this.seamlessLoop.duration());
      this.scrub = gsap.to(this.playhead, { // we reuse this tween to smoothly scrub the playhead on the seamlessLoop
        offset: 0,
        onUpdate() {
          // console.log('scrubbing', parent.wrapTime(parent.playhead.offset));
          parent.seamlessLoop.time(parent.wrapTime(parent.playhead.offset)); // convert the offset to a "safe" corresponding time on the seamlessLoop timeline
        },
        duration: 1.1,
        ease: "power2",
        paused: true
      });


      this.trigger = ScrollTrigger.create({
        start: 0,
        // timeScale: .5,
        onUpdate(self) {
          // console.log('update');
          // console.log(parent.iteration, self.progress, parent.seamlessLoop.duration());
          let scroll = self.scroll();
          if (scroll > self.end - 1) {
            parent.wrap(1, 1);
          } else if (scroll < 1 && self.direction < 0) {
            parent.wrap(-1, self.end - 1);
          } else {
            // console.log('scrub.vars.offset',parent.scrub.vars.offset);
            // parent.scrub.vars.offset = (parent.iteration + self.progress) * parent.seamlessLoop.duration() + window.scrubvarsoffset;
            // parent.scrub.invalidate().restart(); // to improve performance, we just invalidate and restart the same tween. No need for overwrites or creating a new tween on each update.
            // parent.checkFloaters();
          }

          parent.scrub.vars.offset = ((parent.iteration + self.progress) * parent.seamlessLoop.duration()) + window.scrubvarsoffset;
          parent.scrub.invalidate().restart();
          // parent.checkFloaters();

          // console.log(parent.seamlessLoop.time());
        },
        snap: {
          snapTo: 1 / this.children.length,
          directional: false,
          duration: 1.0,
          delay: isSafari ? 0.5 : 0.2,
          ease: "power3"
        },
        // snap: 1 / this.children.length,
        // preventOverlaps: true,
        self: this,
        end: container.get(0).innerHeight,
        pin: scroller,
        scrub: isSafari ? true : 0.2,
        // pin: scroller,
        scroller: container,
        // pinSpacing: true,
      });


      if(isSafari) {
        // console.log('isSafari, no lagSmoothing');
        // gsap.ticker.lagSmoothing(0);
      }


      // converts a progress value (0-1, but could go outside those bounds when wrapping) into a "safe" scroll value that's at least 1 away from the start or end because we reserve those for sensing when the user scrolls ALL the way up or down, to wrap.
      this.progressToScroll = function(progress){
        // console.log(progress, 'prog to scroll');
        return gsap.utils.clamp(1, this.trigger.end - 1, gsap.utils.wrap(0, 1, progress) * this.trigger.end);
      }

      this.wrap = function(iterationDelta, scrollTo){
        this.iteration += iterationDelta;
        this.trigger.scroll(scrollTo);
        this.trigger.update(); // by default, when we trigger.scroll(), it waits 1 tick to update().
      };

      // when the user stops scrolling, snap to the closest item.
      // ScrollTrigger.addEventListener("scrollEnd", function(){
      //   console.log('scrollend', parent.scrub.vars.offset);
      //   console.log('loool');
      //   parent.scrollToOffset(parent.scrub.vars.offset);
      // });


      $(container).off('wheel mousewheel').on('wheel mousewheel', function(e){
        e.preventDefault();
        let delta = e.originalEvent.deltaY;
        delta = Math.min(delta, 100);
        delta = Math.max(-100, delta);
        $(this).scrollTop($(this).scrollTop()+delta);
      });

      this.scrollToOffset(0);

    }
  }

  // feed in an offset (like a time on the seamlessLoop timeline, but it can exceed 0 and duration() in either direction; it'll wrap) and it'll set the scroll position accordingly. That'll call the onUpdate() on the trigger if there's a change.
  scrollToOffset(offset) { // moves the scroll playhead to the place that corresponds to the totalTime value of the seamlessLoop, and wraps if necessary.
    // console.log(this);

    let snappedTime = this.snapTime(offset),
    progress = (snappedTime - this.seamlessLoop.duration() * this.iteration) / this.seamlessLoop.duration(),
    scroll = this.progressToScroll(progress);
    // console.log('snappedTime', snappedTime);
    if (progress >= 1 || progress < 0) {
      return this.wrap(progress, scroll);
    }
    this.trigger.scroll(scroll);

    // this.checkFloaters();
  }

  buildSeamlessLoop(items, spacing, animateFunc) {
    //console.log('built seamlessloop');
    let rawSequence = gsap.timeline({paused: true}), // this is where all the "real" animations live
    seamlessLoop = gsap.timeline({ // this merely scrubs the playhead of the rawSequence so that it appears to seamlessly loop
      paused: true,
      repeat: -1, // to accommodate infinite scrolling/looping
      onRepeat() { // works around a super rare edge case bug that's fixed GSAP 3.6.1
        this._time === this._dur && (this._tTime += this._dur - 0.1);
      },
      onReverseComplete() {
        this.totalTime(this.rawTime() + this.duration() * 100); // seamless looping backwards
      }
    }),
    cycleDuration = spacing * items.length,
    dur; // the duration of just one animateFunc() (we'll populate it in the .forEach() below...

    // loop through 3 times so we can have an extra cycle at the start and end - we'll scrub the playhead only on the 2nd cycle
    items.concat(items).concat(items).forEach((item, i) => {
      let anim = animateFunc(items[i % items.length]);
      rawSequence.add(anim, i * spacing);
      dur || (dur = anim.duration());
    });

    // animate the playhead linearly from the start of the 2nd cycle to its end (so we'll have one "extra" cycle at the beginning and end)
    seamlessLoop.fromTo(rawSequence, {
      time: cycleDuration + dur / 2
    }, {
      time: "+=" + cycleDuration,
      duration: cycleDuration,
      ease: "none"
    });
    return seamlessLoop;
  }

  initFloaters(){
    var parent = this;
    // console.log(self);
    parent.floaterBlocks = [];
    parent.blocks = $(parent.self).find('.home--col--block');
    $(parent.blocks).each(function(){
      var block = this;
      block.link = $(this).find('.home--biglink');
      if($(this).find('.floaters--item').length>0){
        block.floaters = $(this).find('.floaters--item');
        block.doFirstCheck = true;
        for(var i=0;i<block.floaters.length;i++){
          if(!block.floaters[i].speed){
            block.floaters[i].speed = Math.random() * 5 + 1;
            block.floaters[i].ident = $(block.floaters[i]).attr('data-id');
            // console.log($('.home--absolute--floaters').children());
            block.floaters[i].absItem = $('.home--absolute--floaters [data-id="'+block.floaters[i].ident+'"]').get(0);
          }
        }
        parent.floaterBlocks.push(block);
      }
    });
  }

  checkFloaters(){
    var parent = this;
    // if(window.allowFloatCheck < Date.now()) {
      for(var i=0; i<parent.floaterBlocks.length;i++){
        let floaterBlock = parent.floaterBlocks[i];
        if(floaterBlock.floaters){
          let blockrect = floaterBlock.getBoundingClientRect();
          var inview = blockrect.top < window.innerHeight-10 && blockrect.bottom > 10;
          if(inview){
            // console.log('inview', floaterBlock);
            floaterBlock.floatersActive = true;
            for(var f=0; f<floaterBlock.floaters.length;f++) {
            // $(floaterBlock.floaters).each(function(){
              let thisFloater = floaterBlock.floaters[f];
              // let id = thisFloater.id;
              // let id = $(thisFloater).attr('data-id');
              var rect = thisFloater.getBoundingClientRect();
              // var mid = rect.top - rect.height/2;
              var prc = (rect.top - rect.height/2) / window.innerHeight;
              var transformValue = ((window.innerHeight * .15) * prc) * thisFloater.speed;
              // console.log(mid,transformValue);

              // var item = thisFloater.absItem;

              if(floaterBlock.doFirstCheck) {
                // console.log('did firstcheck');
                $(thisFloater.absItem).css({
                  'opacity' : 1,
                  'height' : rect.height,
                  'width' : rect.width,
                }); //.removeClass('notrans');
              }

              // console.log(thisFloater.absItem);

              // thisFloater.absItem.style.opacity = 1;
              thisFloater.absItem.style.transform = 'translate3d('+rect.left+'px, '+(rect.top+transformValue)+'px, 0px)';

              // $(thisFloater.absItem).css({
                // 'transform' : 'translate3d('+rect.left+'px, '+(rect.top+transformValue)+'px, 0px)',
                // 'opacity' : 1,
                // 'height' : rect.height,
                // 'width' : rect.width,
              // }); //.removeClass('notrans');

              // clearTimeout(thisFloater.time);
            // });
            }
            floaterBlock.doFirstCheck = false;
            // console.log('viewing a floaterBlock with floaters');
          } else if(!inview && floaterBlock.floatersActive){
            floaterBlock.floatersActive = false;
            floaterBlock.doFirstCheck = true;
            $(floaterBlock.floaters).each(function(){
              let id = $(this).attr('data-id');
              $('.home--absolute--floaters [data-id="'+id+'"]').css('opacity', 0); //.addClass('notrans');
            });
          }
          // console.log('inview: block #',i);
        }
      }
    // }
    // window.allowFloatCheck = Date.now();
  }

} export default homeColumn;
